import React, { useEffect, useState } from 'react';
import { Button, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { AgGridReact } from 'ag-grid-react'; 

interface GridResetButtonProps {
  gridRef: React.RefObject<AgGridReact | null>;
  className?: string;
}

export const GridResetButton: React.FC<GridResetButtonProps> = ({ gridRef, className }) => {
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      const api = gridRef.current?.api;
      if (!api) return;

      const isFiltered = Object.keys(api.getFilterModel() || {}).length > 0;
      const isSorted = api.getColumnState().some(col => !!col.sort);

      const shouldEnable = isFiltered || isSorted;
      setDisabled(!shouldEnable);
    }, 300); // Check every 300ms (adjust if needed)

    return () => clearInterval(interval);
  }, [gridRef]);

  const resetGrid = () => {
    const api = gridRef.current?.api;
    if (!api) return;

    if ('setSortModel' in api && typeof (api as any).setSortModel === 'function') {
      (api as any).setSortModel(null);
    } else {
      api.applyColumnState({ defaultState: { sort: null } });
    }

    api.setFilterModel(null);
    api.onFilterChanged();
  };

  return (
    <Tooltip title="Reset all filters and sorting">
      <Button
        shape="circle"
        icon={<ReloadOutlined />}
        onClick={resetGrid}
        className={className}
        disabled={disabled}
      />
    </Tooltip>
  );
};
